import axios from 'axios'
import {
  get,
  post,
  put
} from '@/util/request'

let prefix = '/api'
// 虹信报表接口域名
let fineBiPrefix = 'https://hkfinebi.hxct.com/webroot/decision'
// let fineBiPrefix = 'https://192.168.8.195/webroot/decision'
// let fineBiPrefix = 'http://10.8.2.64:37799/webroot/decision'
// 扫码跳转的页面
let appUrl = `http://kong.poros-platform.10.74.20.163.nip.io/auth/download`

const isDev = process.env.NODE_ENV === "development"
if (!isDev) {
  prefix = location.origin + '/api'
  appUrl = location.origin + `/auth/download`
}
export const downloadPage = appUrl
export const downloadIosUrl = prefix

/*report */
export const reportListApi = `${fineBiPrefix}/v5/api/dashboard/user/info`
export const reportDetail = `${fineBiPrefix}/v5/design/report`

/* 字典 */
export function getDictory(...args) {
  return get(`${prefix}/poros-permission/dict/data/list`, ...args)
}

// 下载app接口 获取最新上架的各平台上架应用
export function getDownloadApp(...args) {
  return get(`${prefix}/poros-mobile/appVersion/version/last`, ...args)
}

/*鸡汤 */
export function getChicken() {
  return get(`${prefix}/poros-mobile/chickenSoupForTheSoul/get`)
}

/*公告管理列表 */
export function getNoticeList(...args) {
  return get(`${prefix}/poros-mobile/appAd/nowTime`, ...args)
}

/*待办流程列表 */
export function getAssignList(...args) {
  return get(`${prefix}/poros-bpmengine/task/getAssigneeTaskList`, ...args)
}
/*已办流程列表 */
export function getDoneList(...args) {
  return get(`${prefix}/poros-bpmengine/task/getDoneTaskList`, ...args)
}
/*我的申请列表 */
export function getMyList(...args) {
  return get(`${prefix}/poros-bpmengine/process/getMyList`, ...args)
}

/** 注册接口 */
export function registerApi(...args) {
  return post(`${prefix}/poros-authcenter/register/save`, ...args)
}
/** 新增供应商接口 */
export function addSupplierApi(...args) {
  return axios.post(`${prefix}/poros-permission/secStaff/addSupplier`, ...args)
}
/**获取临时token用于注册供应商 */
export function getTmpToken(...args){
  return get(`${prefix}/srm-supplier/auto/srmsmSupinfoForSupPlus/getToken`, ...args)
}
/** 供应商注册成功后请求的接口 */
export function saveSupUserinfo(args, config) {
  let str = '',arr = []
  for(let i in args){
    arr.push(`${i}=${args[i]}`)
  }
  str = '?' + arr.join("&")
  return axios.post(`${prefix}/srm-supplier/auto/srmsmSupinfoUser/saveSupUserinfo${str}`, {}, config)
}
/** 注册：发送验证码 */
export function registerSendCodeApi(...args) {
  return get(`${prefix}/poros-authcenter/register/sendCode`, ...args)
}
/** 用户名是否已经存在 */
export function isExistApi(...args) {
  return get(`${prefix}/poros-authcenter/register/isExist`, ...args)
}
/** 登录接口 */
export function loginApi(...args) {
  return post(`${prefix}/poros-authcenter/login`, ...args)
}
/** 找回密码：发送邮件 */
export function resetSendCodeApi(...args) {
  return post(`${prefix}/poros-authcenter/reset/sendCode`, ...args)
}
/** 重置密码页：根据token获取用户信息 */
export function getResetInfoApi(...args) {
  return get(`${prefix}/poros-authcenter/reset/data`, ...args)
}
/** 通过邮件重置密码 */
export function resetByEmailApi(...args) {
  return post(`${prefix}/poros-authcenter/reset/email`, ...args)
}
/** 通过token重置密码 */
export function resetByTokenApi(...args) {
  return put(`${prefix}/poros-authcenter/reset/user`, ...args)
}
/** 通过手机号重置密码 */
export function resetByMobileApi(...args) {
  return post(`${prefix}/poros-authcenter/reset/mobile`, ...args)
}
/** 查询当前用户信息 */
export function getUserMessageApi() {
  return get(`${prefix}/poros-authcenter/user/message`)
}
/** 登出接口 */
export function logoutApi() {
  return get(`${prefix}/poros-authcenter/user/logout`)
}
/** 根据用户名或手机号获取密钥 */
export function getSecretKeyApi(username, ...args) {
  return get(`${prefix}/poros-authcenter/secret/${username}`, ...args)
}
/** 修改密码 */
export function updatePasswordApi(...args) {
  return put(`${prefix}/poros-authcenter/reset/userAuth`, ...args)
}
/** 查询当前用户有权限访问的系统列表 */
export function getPermissionApi() {
  return get(`${prefix}/poros-permission/sys/uid`)
}
/** 获取ad域token */
// export const getAdToeknUrl = `${prefix}/poros-authcenter/oauth/ad`

// 获取用户信息
export function getCurUser () {
  return get(`${prefix}/poros-permission/secStaff/getCurUser`);
}